/*
    Страница истории
*/

const $historyYearsTitles = $('.js-history-year-title');

/* Скролл по анкору при клике на год */
$('.js-history-year-anchor').on('click', function (e) {
    let currYear = $(this).attr('href');
    let currYearWrapper = $historyYearsTitles.filter(`[data-year=${currYear}]`);

    $('html, body').animate({scrollTop: currYearWrapper.offset().top - 150}, 700);

    e.preventDefault();
});


// WEBPACK FOOTER //
// ./_src/js/modules/PageHistory.js